import axios from './financeiroApi';

const getPath = () => `/api/v1/backend/vendedor`;

const vendedorApi = {
  get: (search) => {
    const url = `${getPath()}?page=${search.page}&size=${search.size}${
      search.q ? `&q=${search.q}` : ''
    }&sort=${search.sort || 'pessoa.nome,ASC'}`;
    return axios.get(url);
  },
  getOne: (vendedorId) => {
    const url = `${getPath()}/${vendedorId}`;
    return axios.get(url);
  },
  post: (vendedor) => {
    const url = `${getPath()}`;
    return axios.post(url, vendedor);
  },
  put: (vendedor) => {
    const url = `${getPath()}/${vendedor.id}`;
    return axios.put(url, vendedor);
  },
  delete: (filtro) => {
    return axios.delete(getPath(), { data: filtro });
  },
  pesquisar: (params) => {
    const url = `${getPath()}/pesquisar`;
    return axios.get(url, { params });
  },
};

export { vendedorApi };
